import { ENDPOINTS } from "../constants";
import { User } from "../types/types";
import { fetchResource } from "../utils/fetch-resource";

export function me(): Promise<User> {
  return fetchResource<User>(ENDPOINTS.ME);
}
